
import { Capacitor } from '@capacitor/core';
import { AdMob } from '@capacitor-community/admob';
import { MotionPlugin } from '@vueuse/motion'
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'styles/index.scss';
import app from './index.vue';
import Preload from './scenes/preload.vue';
import Menu from './scenes/menu.vue';
import Game from './scenes/game.vue';
import Sortable, { Swap } from 'src/lib/sortable.core.esm.js';

console.log("Mode: " + process.env.NODE_ENV);
console.log("DBMode: " + DB_MODE);
console.log("PLatform: " + Capacitor.getPlatform());

//Clear all cookies (comment out before build!)
// localStorage.clear();
// document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });

/**
 * Initialize admob 
 */
AdMob.initialize({
   requestTrackingAuthorization: false,
   testingDevices: ['42b01f05-ffc4-4cf0-b217-330352303658', '1e60e91934a19982b4c87634ea2e7e4e'],
   initializeForTesting: process.env.NODE_ENV === 'development',
});

// @ts-ignore
Sortable.mount(new Swap()); 

let App = createApp(app);
    App.use(createPinia());
    App.use(MotionPlugin);
    App.component('Preload', Preload)
       .component('Menu', Menu)
       .component('Game', Game)

    App.mount('#app');